import { api } from './index';

import type { SessionFeedback } from '@/types';

export interface CreateFeedbackParams {
  category: string;
  content: string;
  sessionId: string;
}

export interface UpdateFeedbackParams {
  id: string;
  category: string;
  content: string;
}

export interface SendAppFeedbackParams {
  text: string;
  typeOfFeedback: string;
}

export const feedbackApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // Create session feedback
    createFeedback: builder.mutation<SessionFeedback, CreateFeedbackParams>({
      invalidatesTags: ['Session'],
      query: ({ category, content, sessionId }) => ({
        data: { category, content, sessionId },
        method: 'POST',
        url: '/session_feedback',
      }),
    }),

    // Update session feedback
    updateFeedback: builder.mutation<SessionFeedback, UpdateFeedbackParams>({
      invalidatesTags: ['Session'],
      query: ({ id, category, content }) => ({
        data: { category, content },
        method: 'PUT',
        url: `/session_feedback/${id}`,
      }),
    }),

    // Send app feedback
    sendAppFeedback: builder.mutation<void, SendAppFeedbackParams>({
      query: ({ text, typeOfFeedback }) => ({
        data: { body: text, type: typeOfFeedback },
        method: 'POST',
        url: '/feedback',
      }),
    }),
  }),
});

export const {
  useCreateFeedbackMutation,
  useUpdateFeedbackMutation,
  useSendAppFeedbackMutation,
} = feedbackApi;
